import { useState } from "react";

import { sortBy } from "lodash/fp";

export interface SortOption<T extends object> {
  id: string;
  label: string;
  sortFn: (value: T) => any; // returns something sortable
}

/**
 * Simple hook for sorting data.
 *
 * @param data list of items to be sorted
 * @param options potential sort options
 * @param defaultSort optional default sort. if not passed, will use the first option passed in the `options` param
 * */
const useSortData = <T extends object>(
  data: T[],
  options: SortOption<T>[],
  defaultSort?: SortOption<T>
) => {
  const [selectedSort, setSelectedSort] = useState<SortOption<T>>(
    defaultSort ?? options[0]
  );

  const handleSortChange = (option: SortOption<T>) => {
    setSelectedSort(option);
  };

  const sortedData = sortBy(selectedSort.sortFn, data);

  return {
    selectedSort,
    sortedData,
    onSortChange: handleSortChange,
  };
};

export default useSortData;
